/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const salesforceAiConnectorName = "p0-connector-salesforce-ai";

/** Canonical (AWS-style) Secret Manager id of an org's provisioner consumer
 * secret. Other providers rewrite it with their `replacer`. */
export const salesforceAiConsumerSecretSecretId = (orgId: string): string =>
  `p0/install/salesforce/${orgId}/consumer-secret`;
